module.exports = __webpack_public_path__ + "img/k3.c1310009.png";